import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'

function decorator(
  config = {
    notFor: []
  }
) {
  return ComposedComponent => {
    @connect(({ auth }) => ({
      user: auth.user,
      activeOrganization: auth.organization
    }))
    class Permissions extends Component {
      static propTypes = {
        activeOrganization: PropTypes.object.isRequired
      }

      render() {
        const { activeOrganization } = this.props

        const permissions = {
          activeRole: getActiveRole(activeOrganization),
          isIf:
            getActiveRole(activeOrganization) === ROLES.IF_STAFF_SUPER.u ||
            getActiveRole(activeOrganization) === ROLES.IF_STAFF_USER.u ||
            getActiveRole(activeOrganization) === ROLES.IF_STAFF_VIEWER.u ||
            getActiveRole(activeOrganization) === ROLES.IF_REGION.u,
          isIfSuper:
            getActiveRole(activeOrganization) === ROLES.IF_STAFF_SUPER.u,
          isIfRegion: getActiveRole(activeOrganization) === ROLES.IF_REGION.u,
          isOa: getActiveRole(activeOrganization) === ROLES.OA.u,
          isSoa: getActiveRole(activeOrganization) === ROLES.SOA.u,
          isIfUser: getActiveRole(activeOrganization) === ROLES.IF_STAFF_USER.u,
          isVerifier:
            getActiveRole(activeOrganization) === ROLES.AWARD_VERIFIER.u,
          isIfViewer:
            getActiveRole(activeOrganization) === ROLES.IF_STAFF_VIEWER.u,
          isNaoStaff: getActiveRole(activeOrganization) === ROLES.NAO_STAFF.u,
          isGopStaff: getActiveRole(activeOrganization) === ROLES.GOP_STAFF.u,
          isParticipant:
            getActiveRole(activeOrganization) === ROLES.PARTICIPANT.u,
          isLeader: getActiveRole(activeOrganization) === ROLES.LEADER.u,
          isGbt: getActiveRole(activeOrganization) === ROLES.GBT.u
        }

        permissions.isSuperior =
          permissions.isNaoStaff ||
            permissions.isGopStaff ||
            permissions.isIfSuper ||
            permissions.isGbt ||
            permissions.isIfRegion ||
            permissions.isOa ||
            permissions.isSoa ||
            permissions.isLeader

        if (
          config.notFor.some(
            item => ROLES[item].u === getActiveRole(activeOrganization)
          )
        ) {
          return null
        }

        return <ComposedComponent {...this.props} permissions={permissions} />
      }
    }
    return Permissions
  }
}

export default decorator
